<template>
	<div ref="root"/>
</template>

<script lang="ts">
import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

import Editor from '@toast-ui/editor';
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';

/**
 * Обёртка над ToastUI. Markdown — неуправляемый виджет: создаётся один раз
 * на начальном значении, текст забирается по запросу через getMarkdown().
 * Реактивно value не отслеживается намеренно — иначе обратная запись своего же
 * change вызывает прыжки курсора.
 *
 * readonly=true рисует Viewer (только чтение), иначе Editor.
 */
export default defineComponent({
	name: 'VMarkdownEditor',

	props: {
		value: {
			type:    String,
			default: '',
		},
		readonly: {
			type:    Boolean,
			default: false,
		},
		/** Высота редактора (для Viewer игнорируется) */
		height: {
			type:    String,
			default: 'calc(100vh - 222px)',
		},
	},

	emits: ['dirty'],

	data() {
		return {
			instance: null as Editor | Viewer | null,
		};
	},

	mounted() {
		this.createInstance();
	},

	beforeUnmount() {
		this.destroyInstance();
	},

	methods: {
		/** Текущий markdown из редактора. Для Viewer возвращает исходное value. */
		getMarkdown(): string {
			if (this.instance instanceof Editor) {
				return this.instance.getMarkdown();
			}
			else {
				return this.value;
			}
		},

		createInstance(): void {
			if (this.readonly) {
				this.instance = new Viewer({
					el:           this.$refs.root as HTMLElement,
					initialValue: this.value,
				});
			}
			else {
				this.instance = new Editor({
					el:                      this.$refs.root as HTMLElement,
					height:                  this.height,
					initialValue:            this.value,
					previewStyle:            'tab',
					language:                'ru-RU',
					useCommandShortcut:      true,
					useDefaultHTMLSanitizer: false,
					usageStatistics:         false,
					hideModeSwitch:          true,
					initialEditType:         'markdown',
					events:                  {
						change: (event: any) => {
							if (this.$core.utils.isObject(event) && event.source === 'markdown') {
								this.$emit('dirty');
							}
						},
					},
					toolbarItems: [
						['heading', 'bold', 'italic', 'strike'],
						['hr', 'quote'],
						['ul', 'ol', 'task', 'table'],
						['image', 'link'],
						['code', 'codeblock'],
					],
				});
			}
		},

		destroyInstance(): void {
			if (this.instance instanceof Editor) {
				this.instance.destroy();
			}
			this.instance = null;
		},
	},
});
</script>